import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgForOf } from '@angular/common';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslateModule } from '@ngx-translate/core';
import { REPORT_TYPE_FILTERS } from './report-type-filters.config';
import { ReportTypeModel } from './report-type-filters.types';

@UntilDestroy()
@Component({
  selector: 'tax-report-type-filters',
  templateUrl: 'report-type-filters.component.html',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ReportTypeFiltersComponent),
      multi: true,
    },
  ],
  imports: [
    NgForOf,
    TranslateModule,
  ],
})
export class ReportTypeFiltersComponent implements ControlValueAccessor {
  selectedReportType: ReportTypeModel | null = null;
  readonly reportTypeFilters = REPORT_TYPE_FILTERS;

  selectReportType(reportType: ReportTypeModel): void {
    this.selectedReportType = reportType.value !== this.selectedReportType?.value ? reportType : null;
    this.onChange(this.selectedReportType);
    this.onTouched();
  }

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  writeValue(value: ReportTypeModel): void {
    this.selectedReportType = value;
  }

  private onChange = (reportType: ReportTypeModel | null): void => {};
  private onTouched = (): void => {};
}
